// src/config.js
export const IMAGE_VERSION = '1';

export const IMAGES_CDN = 
  'https://cdn.jsdelivr.net/gh/gstewart88/wrestler-images@493a841/thumbs';
